import { render, staticRenderFns } from "./updateLoginPassword.vue?vue&type=template&id=0fadfa05&scoped=true&"
import script from "./updateLoginPassword.vue?vue&type=script&lang=js&"
export * from "./updateLoginPassword.vue?vue&type=script&lang=js&"
import style0 from "./updateLoginPassword.vue?vue&type=style&index=0&id=0fadfa05&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fadfa05",
  null
  
)

export default component.exports